import AssetLoader from "@/components/AssetLoader/AssetLoader";
import CDNLink from "@/components/CDNLink/CDNLink";
import ModalManager from "@/components/ModalComponent/ModalManager";
import PDFViewer from "@/components/PDFViewer/PDFViewer";
import { AssetTypes } from "@/model/AssetTypes";
import { Invoice } from "../../RAInterfaces";
import RAInvoiceEntryViewFields from "../RAInvoiceEntryViewFields";
import RABookInvoiceForm from "./RABookInvoiceForm";
import "./RABookInvoiceModal.scss";

export const openInvoiceBooking = (id: string, onFinish: () => void) => {
  ModalManager.show({
    size: "full",
    modalClassName: "ra-book-invoice-modal_full",
    noPadding: true,
    content: (state, setState, close) => (
      <AssetLoader
        assetType={AssetTypes.Invoicing.Invoice}
        id={id}
        render={(invoice: Invoice) => {
          const fileCdnData = invoice?.data?.invoice?.file || {};
          return (
            <div className={`ra-book-invoice-modal`}>
              <div className={`form-container`}>
                <div className={`invoice-entry-view`}>
                  <RAInvoiceEntryViewFields
                    invoice={invoice}
                    maxHistoryHeight={350}
                    showInvoiceId
                    hideCostCenter
                    hideInfoFields
                    hideRelations

                    // ignoreHistory
                    // hideTags
                  />
                </div>
                <RABookInvoiceForm
                  asset={invoice}
                  onClose={close}
                  onFinish={() => {
                    onFinish();

                    close();
                  }}
                />
              </div>
              <div className="invoice-pdf padding-10">
                {fileCdnData && (
                  <CDNLink
                    assetType={AssetTypes.Invoicing.Invoice}
                    assetId={invoice?._id}
                    assetField={"data.invoice.file"}
                    cdnId={fileCdnData.id}
                    filename={fileCdnData.filename}
                    fileKey={fileCdnData.key}
                    hasFolderReadPermissions={true}
                    render={(url) => (
                      <PDFViewer
                        zoomFactorStorageKey={"pdf_zoom_factor_full_view"}
                        url={url}
                        // highlights={highlight}
                        filename={fileCdnData.filename}
                      />
                    )}
                  />
                )}
                <div className={`inset-shadow`} />
              </div>
            </div>
          );
        }}
      />
    ),
  });
};
